<template>
  <el-dialog
    :title="$t('app.operationPermission')"
    :visible.sync="dialogVisible"
    width="500px"
    class="role-management-permission"
  >
    <el-tree
      ref="tree"
      :data="data"
      :check-strictly="true"
      show-checkbox
      node-key="id"
      :props="defaultProps"
    >
    </el-tree>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import {
  getOperationPermission,
  saveOperationPermission,
} from "@/api/systemManagement/roleManagement";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      code: "",
      data: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      permission: [],
    };
  },
  methods: {
    edit(row) {
      this.permission.length = 0;
      this.dialogVisible = true;
      this.code = row.code;
      getOperationPermission({ RoleCode: row.code }).then((res) => {
        this.data = this.getTree(res.data);
        console.log(this.data)
        console.log(this.permission)
        this.$refs.tree.setCheckedKeys(this.permission);
      });
    },
    getTree(array) {
      return array.map((item) => {
        if (item.Subset.length) {
          return {
            id: item.MenuCode,
            label: item.MenuName,
            children: this.getTree(item.Subset),
          };
        } else {
          if (item.IsChecked) {
            this.permission.push(item.MenuCode);
          }
          return {
            id: item.MenuCode,
            label: item.MenuName,
            children: item.PermissionGroup.map((item) => {
              if (item.IsChecked) {
                this.permission.push(item.PermissionCode);
              }
              return {
                id: item.PermissionCode,
                label: item.PermissionName,
              };
            }),
          };
        }
      });
    },
    handleClose() {
      this.$confirm(this.$t("app.confirmModification") + "?").then(() => {
        this.loading = true;
        saveOperationPermission({
          RoleCode: this.code,
          SelectedPermissionGroup: this.$refs.tree.getCheckedKeys(),
        })
          .then(() => {
            this.success();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.loading = false;
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss">
.role-management-permission {
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner {
      display: inline-block;
    }
    .el-checkbox .el-checkbox__inner {
      display: none;
    }
  }
}
</style>
